<template>
  <div
    v-if="haveComment !== false"
    class="comment-list"
    :class="isH5 ? 'h5-comment-list' : 'pc-comment-list'"
  >
    <!-- 整体评价 -->
    <div class="total-wrap">
      <!-- score -->
      <div class="scores">
        <div class="total-score">
          <span v-if="courseComment.star" class="total-value">{{
            courseComment.star.toFixed(1)
          }}</span>
          <p class="star-wrap">
            <span class="title">整体评价</span>
            <Star :score="courseComment.star" key="total" />
          </p>
        </div>
        <ul class="subScore">
          <li v-for="item in subScore" :key="item.name" class="score-item">
            <span class="title">{{ item.title }}</span>
            <span v-if="courseComment[item.name]" class="value">
              {{ courseComment[item.name].toFixed(1) }}</span
            >
          </li>
        </ul>
      </div>
      <!-- tag -->
      <ul
        v-if="courseComment.tag && courseComment.tag.length"
        class="tag-count"
      >
        <li v-for="tag in courseComment.tag" :key="tag.tag">
          <span class="tag">{{ tagName(tag.tag) }}</span>
          <span class="count">（{{ million(tag.count) }}）</span>
        </li>
      </ul>
    </div>
    <div class="filter-wrap">
      <el-checkbox @change="handleFilter" v-model="comment_state"></el-checkbox>
      只看有内容的评价
    </div>
    <ul v-if="commentList && commentList.length" class="comments">
      <li v-for="(item, index) in commentList" :key="item.id" class="item-wrap">
        <img
          v-if="item.quality === 1"
          class="quality"
          src="../../../assets/images/product-details/quality.png"
          alt=""
        />
        <p class="user-info">
          <img
            v-if="item.anonymity === 1"
            class="avatar"
            src="https://cdn.moguocdn.com/cdn/static/images/default_avatar.png?imageView2/0/w/100"
            alt=""
          />
          <img
            v-else
            class="avatar"
            :src="item.avatar + '?imageView2/0/w/100'"
            alt=""
          />
          <span v-if="item.anonymity === 1" class="user-name">匿名用户</span>
          <span v-else class="user-name">{{ item.nickname }}</span>
          <Star class="item-star" :score="item.star" :key="item.id" />
        </p>
        <ul v-if="item.tag && item.tag.length" class="tags">
          <li v-for="ele in item.tag" :key="ele">{{ tagName(ele) }}</li>
        </ul>
        <div v-if="item.comment" class="comment-cont">{{ item.comment }}</div>
        <div
          v-if="item.comment_img && item.comment_img.length"
          class="image-list"
        >
          <img
            @click="handlePreview(index, item.id)"
            class="img-item"
            v-for="(img, index) in item.comment_img"
            :key="img + index"
            :src="handleCommentImage(img)"
            alt=""
          />
          <el-image
            :key="item.id"
            style="display: none"
            :ref="'elImage' + item.id"
            :initial-index="initialIndex"
            src=""
            :preview-src-list="handlePreviewList(item.comment_img)"
          ></el-image>
        </div>
        <p v-if="noContent(item)" class="no-content">此用户未填写评价内容</p>
        <div class="bottom-wrap">
          <p class="time-wrap">
            <span class="time">{{
              moment(item.last_update_time * 1000).format("YYYY.MM.DD HH:mm")
            }}</span>
            <span v-if="!isH5">学习 {{ item.lesson_count }} 课时评价</span>
          </p>
          <div class="comment-like">
            <span v-if="isH5">学习 {{ item.lesson_count }} 课时评价</span>
            <p class="like-num" :class="{ active: item.is_like === 1 }">
              <span v-if="item.like" class="num">{{ item.like }}</span>
              <span v-else class="num">有用</span>
              <button
                :disabled="submiting"
                v-preventReClick
                @click="handleLike(item, index)"
                class="like-img"
              ></button>
            </p>
          </div>
        </div>

        <!-- 回复 -->
        <div v-if="item.replier" class="teacher-reply">
          <p class="time">
            <span class="font-18">老师回复：</span>
            <span>{{
              moment(item.replier_time * 1000).format("YYYY.MM.DD HH:mm")
            }}</span>
          </p>
          <!-- eslint-disable-next-line prettier/prettier -->
          <p style="white-space: pre-wrap" class="font-18">{{ item.replier }}</p>
        </div>
      </li>
    </ul>
    <el-empty
      v-else
      description="暂无有内容的评价"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>

    <!-- 查看更多 -->
    <div v-if="total > page_size" class="show-more">
      <p v-if="noMore">没有更多了~</p>
      <p v-else @click="showMore" class="have-more">
        查看更多评价<i class="el-icon-arrow-down"></i>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { TAGLIST } from "@saas/components/src/constants/comment";
import {
  getCommentList,
  getCourseComment,
  commentLike,
} from "@saas/server-api/src/comment";
import { isHXApp, isH5, Star, million } from "@saas/components";
export default {
  props: {
    course_id: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      million,
      haveComment: null,
      comment_state: false,
      courseComment: {},
      moment,
      isHXApp: isHXApp(),
      isH5: isH5(),
      page_no: 1,
      page_size: 10,
      total: 0,
      noMore: false, //没有更多
      loading: false, //加载数据中
      commentList: [],
      tagList: TAGLIST,
      scores: {
        star: 5,
        content_star: 4,
        aura_star: 3,
        teacher_star: 2,
      },
      initialIndex: 0,
      comment_img: [],
      subScore: [
        {
          name: "content_star",
          title: "课程内容",
        },
        {
          name: "aura_star",
          title: "课堂氛围",
        },
        {
          name: "teacher_star",
          title: "老师风采",
        },
      ],
      submiting: false,
    };
  },
  mounted() {
    this.isH5 = isH5();
  },
  methods: {
    showMore() {
      this.page_no += 1;
      this.apiGetCommentList();
    },
    handleFilter() {
      this.page_no = 1;
      this.apiGetCommentList();
    },
    handleLike(item, index) {
      let { id, is_like, like } = item;
      if (this.isAuthenticated) {
        if (this.submiting) {
          return false;
        }
        this.submiting = true;
        let params = {
          comment_id: id,
          is_like: is_like === 1 ? 0 : 1,
        };
        commentLike(params).then((res) => {
          if (res.code === 1) {
            this.commentList[index].is_like = params.is_like;
            this.commentList[index].like =
              params.is_like === 1 ? like + 1 : like - 1;
          } else {
            this.$message.error(res.message);
          }
          this.submiting = false;
        });
      } else {
        // 未登录
        this.$emit("jumpLoginPage");
      }
    },
    apiGetCourseComment() {
      let params = {
        course_id: this.course_id,
      };
      getCourseComment(params).then((res) => {
        if (res.code === 1) {
          // tag 按照数量排序
          let data = res.data || {};
          if (data?.tag?.length) {
            data.tag.sort((a, b) => {
              return b.count - a.count;
            });
          }
          this.courseComment = data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    apiGetCommentList() {
      let params = {
        course_id: this.course_id,
        page_no: this.page_no,
        page_size: this.page_size,
      };
      if (this.comment_state) {
        params.comment_state = 1;
      }
      getCommentList(params).then((res) => {
        if (res.code === 1) {
          let arr = res.data?.list || [];
          if (this.page_no === 1) {
            this.total = res?.data?.total || 0;
            if (this.haveComment === null && this.total) {
              this.haveComment = true;
              this.$emit("commentTotal", this.total);
              // 获取评价总结
              this.apiGetCourseComment();
            } else if (this.haveComment === null) {
              this.haveComment = false;
            }
            this.commentList = arr;
          } else {
            this.commentList = this.commentList.concat(arr);
          }
          if (this.commentList.length === res.data.total) {
            this.noMore = true;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handlePreview(index, id) {
      this.initialIndex = index;
      this.$refs["elImage" + id][0].clickHandler();
    },
  },
  components: {
    Star,
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    tagName() {
      return (id) => {
        return this.tagList.filter((item) => {
          return item.id === id;
        })[0]?.name;
      };
    },
    noContent() {
      return (item) => {
        return (
          !item.tag?.length && !item?.comment && !item?.comment_img?.length
        );
      };
    },
    handleCommentImage() {
      return (img) => {
        if (img.startsWith("https") || img.startsWith("http")) {
          return img + "?imageView2/0/w/200";
        } else {
          return `https:${img}?imageView2/0/w/200`;
        }
      };
    },
    handlePreviewList() {
      return (arr) => {
        return arr.map((item) => {
          if (item.startsWith("https") || item.startsWith("http")) {
            return item;
          } else {
            return `https:${item}`;
          }
        });
      };
    },
  },
  watch: {
    course_id: {
      handler: function (newVal) {
        if (newVal) {
          this.apiGetCommentList();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-comment-list {
  background: #fff;
  .show-more {
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 14px;
    color: #515350;
    line-height: 20px;
    padding: 15px 0 30px;
    .have-more {
      color: #00c89d;
      padding: 0 5px;
      cursor: pointer;
    }
    .have-more i {
      font-size: 12px;
      margin-left: 3px;
    }
  }
  .no-content {
    font-weight: 400;
    font-size: 18px;
    color: #515350;
    line-height: 25px;
  }
  .total-wrap {
    margin: 0 auto 12px;
    width: 768px;
    border-radius: 18px;
    padding: 21px 24px;
    background-image: url("../../../assets/images/product-details/comment-bg.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .scores {
    display: flex;
    align-items: center;
    padding-left: 15px;
  }
  .total-score {
    display: flex;
    align-items: center;
    margin-right: 100px;

    .total-value {
      font-weight: 600;
      font-size: 28px;
      color: #0d1400;
      line-height: 40px;
      margin-right: 20px;
    }
    .star-wrap {
      .title {
        font-weight: 600;
        font-size: 16px;
        color: #0d1400;
        line-height: 22px;
        margin-bottom: 6px;
        margin-left: 6px;
        display: inline-block;
      }
    }
  }
  .subScore {
    display: flex;
    align-items: center;
    .score-item {
      display: flex;
      align-items: center;
      margin-right: 40px;
      .title {
        font-weight: 400;
        font-size: 16px;
        color: #0d1400;
        line-height: 22px;
        margin-right: 12px;
      }
      .value {
        font-weight: 600;
        font-size: 18px;
        color: #ff8034;
        line-height: 25px;
      }
    }
    .score-item:last-child {
      margin-right: 0;
    }
  }
  .tag-count {
    padding-top: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    li {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 80px;
      height: 60px;
      background: #ffffff;
      border-radius: 12px;
      margin-right: 11px;
    }
    li:last-child {
      margin-right: 0;
    }
    .tag,
    .count {
      font-weight: 500;
      font-size: 14px;
      color: #515350;
      line-height: 20px;
    }
    .count {
      font-weight: 400;
    }
  }

  .filter-wrap {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #515350;
    line-height: 20px;
    padding-left: 34px;
  }

  .comments {
    .quality {
      position: absolute;
      width: 58px;
      top: 6px;
      right: 0;
    }
    .item-wrap {
      position: relative;
      margin: 0 32px;
      padding: 16px 0;
      border-bottom: 1px solid #efefef;
    }
    .item-wrap:first-child {
      padding-top: 12px;
    }
    .item-wrap:last-child {
      border-bottom: none;
    }
    .user-info {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
    }
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #e2e2e2;
      object-fit: cover;
      margin-right: 12px;
    }
    .user-name {
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      line-height: 25px;
      margin-right: 12px;
    }
    .tags {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 12px;
      li {
        width: 85px;
        height: 30px;
        background: rgba(0, 200, 157, 0.08);
        border-radius: 15px;
        font-weight: 400;
        font-size: 16px;
        color: #00c89d;
        line-height: 30px;
        margin-right: 8px;
        text-align: center;
      }
      li:last-child {
        margin-right: 0;
      }
    }
    .comment-cont {
      white-space: pre-wrap;
      font-weight: 400;
      font-size: 18px;
      color: #0d1400;
      line-height: 25px;
      margin-bottom: 12px;
      word-break: break-all;
    }
    .image-list {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      img {
        width: 90px;
        height: 90px;
        border-radius: 14px;
        border: 1px solid #efefef;
        margin-right: 16px;
        object-fit: cover;
        cursor: pointer;
      }
      img:last-child {
        margin-right: 0;
      }
    }
    .bottom-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .time-wrap {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
        .time {
          margin-right: 32px;
        }
      }
      .like-num {
        display: flex;
        align-items: center;
      }
      .like-img {
        position: relative;
        top: -2px;
        cursor: pointer;
        width: 18px;
        height: 18px;
        background-image: url("../../../assets/images/product-details/like.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .num {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
        margin-right: 6px;
      }
      .active {
        .num {
          color: #00c89d;
        }
        .like-img {
          background-image: url("../../../assets/images/product-details/active-like.png");
        }
      }
    }

    .teacher-reply {
      background: #f7f8f9;
      border-radius: 16px;
      padding: 12px;
      margin-top: 12px;
      .time {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
        margin-bottom: 3px;
      }
      .font-18 {
        font-size: 18px;
      }
    }

    ::v-deep .item-star .star-item {
      width: 20px;
      height: 20px;
    }
  }
}

.h5-comment-list {
  background: #fff;
  .show-more {
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 0.37rem;
    color: #515350;
    line-height: 0.53rem;
    padding: 0.36rem 0 0.72rem;
    .have-more {
      color: #00c89d;
      padding: 0 0.1rem;
      cursor: pointer;
    }
    .have-more i {
      font-size: 12px;
      margin-left: 3px;
    }
  }
  .no-content {
    font-weight: 400;
    font-size: 0.4rem;
    color: #515350;
    line-height: 0.56rem;
  }

  .total-wrap {
    margin: 0 auto 0.27rem;
    width: 9.36rem;
    border-radius: 0.48rem;
    padding: 0.32rem 0.27rem 0;
    background-image: url("../../../assets/images/product-details/comment-bg.png");
    background-size: auto 100%;
    background-repeat: no-repeat;
  }
  .scores {
    display: flex;
    flex-direction: column;
  }
  .total-score {
    display: flex;
    align-items: center;

    .total-value {
      font-weight: 600;
      font-size: 0.75rem;
      color: #0d1400;
      line-height: 1.04rem;
      padding-right: 0.55rem;
      padding-left: 0.37rem;
    }
    .star-wrap {
      .title {
        font-weight: 600;
        font-size: 0.43rem;
        color: #0d1400;
        line-height: 0.6rem;
        margin-bottom: 0.15rem;
        margin-left: 0.13rem;
        display: inline-block;
      }
    }
  }
  .subScore {
    margin-top: 0.23rem;
    display: flex;
    align-items: center;
    padding-bottom: 0.27rem;
    .score-item {
      display: flex;
      align-items: center;
      margin-right: 40px;
      .title {
        font-weight: 400;
        font-size: 0.37rem;
        color: #0d1400;
        line-height: 0.53rem;
        margin-right: 0.13rem;
      }
      .value {
        font-weight: 600;
        font-size: 0.4rem;
        color: #ff8034;
        line-height: 0.56rem;
      }
    }
    .score-item:last-child {
      margin-right: 0;
    }
  }
  .tag-count {
    padding-top: 0.21rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    li {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 2.03rem;
      height: 1.6rem;
      background: #ffffff;
      border-radius: 0.32rem;
      margin-right: 0.23rem;
      margin-bottom: 0.27rem;
    }
    li:nth-child(4n) {
      margin-right: 0;
    }
    .tag,
    .count {
      font-weight: 500;
      font-size: 0.37rem;
      color: #515350;
      line-height: 0.53rem;
    }
    .count {
      font-weight: 400;
    }
  }

  .filter-wrap {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 0.37rem;
    color: #515350;
    line-height: 0.53rem;
    margin-left: 0.45rem;
  }

  .comments {
    .quality {
      position: absolute;
      width: 0.99rem;
      top: 0.27rem;
      right: 0;
    }
    .item-wrap {
      position: relative;
      margin: 0 0.45rem;
      padding: 0.27rem 0;
      border-bottom: 0.01rem solid #efefef;
    }
    .item-wrap:last-child {
      border-bottom: none;
    }
    .user-info {
      display: flex;
      align-items: center;
      margin-bottom: 0.27rem;
    }
    .avatar {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 0.53rem;
      border: 0.03rem solid #e2e2e2;
      object-fit: cover;
      margin-right: 0.27rem;
    }
    .user-name {
      max-width: 2.5rem;
      font-weight: 400;
      font-size: 0.4rem;
      color: #000000;
      line-height: 0.56rem;
      margin-right: 0.43rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .tags {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 12px;
      li {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.03rem;
        height: 0.72rem;
        background: rgba(0, 200, 157, 0.08);
        border-radius: 0.4rem;
        font-weight: 400;
        font-size: 0.37rem;
        color: #00c89d;
        line-height: 1;
        margin-right: 0.32rem;
        margin-bottom: 0.21rem;
        text-align: center;
      }
      li:nth-child(4n) {
        margin-right: 0;
      }
    }
    .comment-cont {
      white-space: pre-wrap;
      font-weight: 400;
      font-size: 0.4rem;
      color: #000000;
      line-height: 0.56rem;
      margin-bottom: 0.27rem;
      word-break: break-all;
    }
    .image-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      img {
        width: 2rem;
        height: 2rem;
        border-radius: 0.32rem;
        border: 0.01rem solid #efefef;
        margin-right: 0.24rem;
        margin-bottom: 0.24rem;
        object-fit: cover;
      }
      img:nth-child(4n) {
        margin-right: 0;
      }
    }
    .bottom-wrap {
      .time-wrap {
        .time {
          font-weight: 400;
          font-size: 0.32rem;
          color: #515350;
          line-height: 0.44rem;
        }
      }
      .comment-like {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 400;
        font-size: 0.32rem;
        color: #515350;
        line-height: 0.44rem;
        margin-top: 0.16rem;
      }
      .like-num {
        display: flex;
        align-items: center;
      }
      .like-img {
        position: relative;
        top: -0.03rem;
        width: 0.4rem;
        height: 0.4rem;
        background-image: url("../../../assets/images/product-details/like.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .num {
        font-weight: 400;
        font-size: 0.32rem;
        color: #515350;
        line-height: 0.44rem;
        margin-right: 0.16rem;
      }
      .active {
        .num {
          color: #00c89d;
        }
        .like-img {
          background-image: url("../../../assets/images/product-details/active-like.png");
        }
      }
    }

    .teacher-reply {
      background: #f7f8f9;
      border-radius: 0.21rem;
      padding: 0.32rem;
      margin-top: 0.21rem;
      .time {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 400;
        font-size: 0.37rem;
        color: #747573;
        line-height: 0.53rem;
        margin-bottom: 0.02rem;
      }
      .font-18 {
        font-size: 0.37rem;
        color: #515350;
      }
    }

    ::v-deep .item-star .star-item {
      width: 0.53rem;
      height: 0.53rem;
    }
  }
}
</style>
